import { GridColDef, GridRowParams } from "@mui/x-data-grid"
import { renderCellValue } from "./types/renderCellValue"
import { Checkbox, FormControlLabel } from "@mui/material"

export function getPricingRuleColumns(
  setActions?: (params: GridRowParams<any>) => JSX.Element[],
  renderCellValues?: renderCellValue[],
): GridColDef[] {
  let pricingRuleColumns = [
    {
      field: "ruleId",
      headerName: "Id",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "ruleName",
      headerName: "Rule Name",
      minWidth: 200,
      flex: 0.3,
      filterable: false,
    },
    {
      field: "adjustAmount",
      headerName: "Amount",
      minWidth: 60,
      flex: 0,
      filterable: false,
    },
    {
      field: "ruleType",
      headerName: "Rule Type",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "adjustPriceType",
      headerName: "Adjust Type",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "adjustColumn",
      headerName: "Adjust Column",
      minWidth: 120,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "rounding",
      headerName: "Rounding",
      minWidth: 150,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "duration",
      headerName: "Duration",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
    },
    {
      field: "startDate",
      headerName: "Start",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
      valueGetter: (params) => {
        const src = params.row?.startDate ?? params.row?.startDateTime
        if (!src) return ""
        const d = new Date(src)
        return d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })
      },
    },
    {
      field: "endDate",
      headerName: "End",
      minWidth: 100,
      flex: 0.1,
      filterable: false,
      valueGetter: (params) => {
        const src = params.row?.endDate ?? params.row?.endDateTime
        if (!src) return ""
        const d = new Date(src)
        return d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })
      },
    },
  ] as GridColDef[]

  if (renderCellValues)
    renderCellValues.forEach((renderCellValue) => {
      let pricingRuleColumn = pricingRuleColumns.find(
        (pricingRuleColumn) =>
          pricingRuleColumn.field === renderCellValue.field,
      )
      if (pricingRuleColumn)
        pricingRuleColumn.renderCell = renderCellValue.cellRenderer
    })

  if (setActions)
    pricingRuleColumns.push({
      field: "actions",
      headerName: "Action",
      flex: 0.1,
      minWidth: 10,
      type: "actions",

      getActions: (params: GridRowParams<any>) => setActions(params),
    })

  return pricingRuleColumns
}
